{
  "name": "blanco-admin-fe",
  "type": "module",
  "version": "2.3.1-develop.0",
  "scripts": {
    "install": "cp ./package.json ./src/assets",
    "ng": "ng",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test --watch=false --coverage",
    "watch": "ng test",
    "lint": "ng lint",
    "style-lint": "stylelint  \"src/**/*.scss\" --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.3",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@eslint/js": "^10.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.3",
    "@angular/cdk": "^22.2.3",
    "@angular/cli": "^22.2.3",
    "@angular/compiler-cli": "^22.2.3",
    "@angular/material": "^22.2.3",
    "@sparbanken-syd/auth-backend": "^2.7.1",
    "@sparbanken-syd/blanco-backend": "^3.3.5",
    "@sparbanken-syd/personnummer": "^3.1.0",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.2",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.1.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@types/node": "^24",
    "@vitest/coverage-v8": "^5.0.4",
    "angular-eslint": "^22.6.0",
    "eslint": "^10.13.0",
    "jsdom": "^30.1.1",
    "postcss": "^8.5.6",
    "stylelint": "^17.1.1",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.0.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.72.0",
    "vite": "^8.3.5",
    "vitest": "^5.0.4"
  }
}
